import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Department, CacheService } from 'mapfre-auditlib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AlarmsService {

  className = 'AlarmsService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  //User identity is included on the HTTP token
  getUserNotifications(): Observable<any[]> {
    return this.http.get<any[]>(environment.base_URL + "/users/alarms")
  }

  archiveAlarm(alarm, id, store) {
    return this.http.put(environment.base_URL + `/user-alarms/${id}`, alarm, { params: { store: store } })
  }

  getAlarmCriticalityTypes(cache = true, cacheKey = "alarmCritTypes"): Observable<any[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/alarm-criticality-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  addAlarm(alarm) {
    return this.http.post(environment.base_URL + "/users/alarms", alarm)
  }


  /**
   *  Admin alarm
   */

  getAllAlarms(): Observable<Notification[]> {
    return this.http.get<Notification[]>(environment.base_URL + "/alarm-type")
  }

  newAlarm(alarm) {
    return this.http.post(environment.base_URL + "/alarm-type", alarm)
  }

  updateAlarm(alarm, id) {
    return this.http.put(environment.base_URL + `/alarm-type/${id}`, alarm)
  }


  /**
   * Alarm category types
   */

  getAlarmCategories(cache = true, cacheKey = "alarmCategories"): Observable<Notification[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<Notification[]>(environment.base_URL + "/alarm-type-categories").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

}
